import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactForm from './components/ContactForm';
import ContactDetails from './components/ContactDetails';
import JsonLd from '../../components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://devstander.com';

const contactJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  '@id': `${siteUrl}/contact#webpage`,
  url: `${siteUrl}/contact`,
  name: 'Contact Devstander | Software Development Warsaw',
  description:
    'Get in touch with Devstander. Tell us about your project and we\'ll get back to you within one business day. No commitment required.',
  isPartOf: { '@id': `${siteUrl}/#website` },
  mainEntity: {
    '@type': 'Organization',
    '@id': `${siteUrl}/#organization`,
    name: 'Devstander',
    telephone: '+48532004860',
    email: 'info@devstander.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Nowogrodzka 50/54 - 515',
      postalCode: '00-695',
      addressLocality: 'Warsaw',
      addressCountry: 'PL',
    },
  },
};

export default function Contact() {
  return (
    <>
      <JsonLd data={contactJsonLd} />
      <Navbar />
      <main>
        {/* Page Hero */}
        <section className="relative bg-[#070B14] pt-32 pb-16 overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[#3B82F6]/5 rounded-full blur-3xl pointer-events-none"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
            <div className="max-w-2xl">
              <div className="flex items-center gap-2 mb-5">
                <span className="w-6 h-px bg-[#3B82F6]"></span>
                <span className="text-[#3B82F6] text-xs font-semibold uppercase tracking-widest">
                  Contact Us
                </span>
              </div>
              <h1 className="font-display text-4xl lg:text-5xl font-bold text-white leading-tight mb-5 text-balance">
                Let&apos;s Work Together
              </h1>
              <p className="text-slate-400 text-lg leading-relaxed max-w-xl">
                Tell us about your project and we&apos;ll get back to you within one business day.
                No commitment required.
              </p>
            </div>
          </div>
        </section>

        {/* Main Contact Section */}
        <section className="bg-[#070B14] pb-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
              {/* Form – wider column */}
              <div className="lg:col-span-3">
                <ContactForm />
              </div>
              {/* Details – narrower column */}
              <div className="lg:col-span-2">
                <ContactDetails />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
